/* eslint-disable */
import _ from 'underscore';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/humanize');
function addThousandsSeperators(num, seperator) {
  num = num.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(num)) {
    num = num.replace(pattern, '$1' + seperator + '$2');
  }
  return num;
}
function format(num, options) {
  options = _.defaults({}, options, {
    seperator: ','
  });
  num = addThousandsSeperators(num, options.seperator);
  if (_.isString(options.prefix)) {
    num = options.prefix + num;
  }
  if (_.isString(options.suffix)) {
    num += options.suffix;
  }
  return num;
}
export default {
  format: format
};

